import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';

export const GuestInformationContainer = styled.div<{ lastSection?: boolean }>`
  margin-bottom: 30px;
  border-bottom: ${(props) =>
    props.lastSection ? '1px solid #e6e6e6' : 'none'};
  padding-bottom: ${(props) => (props.lastSection ? '30px' : '0')};
`;

export const FormFieldsContainer = styled.div`
  background-color: ${colors.white};
  margin-top: 16px;
`;

export const SectionHeader = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: ${colors.text.primary};
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StepNumber = styled.span`
  color: ${colors.text.primary};
  border-radius: 50%;
  border: 1px solid ${colors.text.primary};
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
`;

export const GuestSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const GuestLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.text.primary};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const TicketSelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const TicketSelectWrapper = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const DisabledInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid ${colors.border};
  font-size: 16px;
  color: ${colors.text.primary};
  background-color: #f8f9fa;
  transition: all 0.2s ease;
  box-sizing: border-box;
  cursor: not-allowed;

  &:focus {
    outline: none;
    border-color: ${colors.border};
    box-shadow: none;
  }
`;
